module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0016.jpg?v=e13de9fa";